export default __webpack_public_path__ + "static/media/infographic-mobile.69e5eca7.png";